"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MusicView = void 0;
const tsyringe_1 = require("tsyringe");
const View_1 = require("../core/render/View");
const viewModelCollection_1 = require("../viewModelCollection");
const ButtonWidget_1 = require("./widgets/ButtonWidget");
const HeadingWidget_1 = require("./widgets/HeadingWidget");
const HtmlWidget_1 = require("./widgets/HtmlWidget");
let MusicView = class MusicView extends View_1.View {
    constructor(viewNavigator) {
        super();
        this.viewNavigator = viewNavigator;
        this.dataContext = viewModelCollection_1.getMusicViewModel();
        this.dataContext.title = "Music";
        let mainElement = document.createElement("main");
        mainElement.classList.add("main", "main-music");
        this.renderBody = mainElement;
        let heading = new HeadingWidget_1.HeadingWidget(1, "Music");
        this.widgets.push(heading);
        this.createButtons();
        let tableWidget = new HtmlWidget_1.HtmlWidget("table", `
<thead>
    <tr>
        <th>Name</th>
        <th>Date And Time Added</th>
    </tr>
</thead>
`);
        this.dataContext.songManager.getSongs().then(songs => {
            let table = tableWidget.element;
            let tableBody = document.createElement("tbody");
            table.appendChild(tableBody);
            for (let song of songs) {
                let row = tableBody.insertRow();
                let nameCell = row.insertCell();
                let anchor = document.createElement("a");
                anchor.href = "#";
                anchor.addEventListener("click", () => {
                    this.viewNavigator.navigate("MusicDetails", { songId: song.songId });
                });
                anchor.text = song.name;
                nameCell.appendChild(anchor);
                let dateCell = row.insertCell();
                dateCell.textContent = song.dateAdded.toLocaleString();
            }
        });
        this.widgets.push(tableWidget);
    }
    createButtons() {
        let button = new ButtonWidget_1.ButtonWidget();
        button.addOnClickEvent(() => {
            this.viewNavigator.navigate("AddNewSong", null);
        });
        button.text = "Add Song";
        this.widgets.push(button);
    }
    shouldRender() {
        return true;
    }
};
MusicView = __decorate([
    tsyringe_1.injectable(),
    __metadata("design:paramtypes", [Object])
], MusicView);
exports.MusicView = MusicView;
//# sourceMappingURL=MusicView.js.map